import React, { Children, useRef } from 'react';
import {
  A11y,
  Keyboard,
  Navigation as NavigationModule,
  Scrollbar,
} from 'swiper';
import { SwiperSlide } from 'swiper/react';

import type { Maybe } from '@/lib/types';

import { Navigation } from './Navigation';

import * as S from './BoutiqueStorySlider.styles';

export interface SlideProps {
  children: React.ReactNode;
  slidesPerView?: Maybe<number>;
  spaceBetween?: number;
}
const generateSliderKey = (index: number) => {
  return `Slider_` + index;
};
export const BoutiqueStorySlider = ({
  children,
  slidesPerView,
  spaceBetween = 0,
}: SlideProps) => {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  return (
    <>
      <S.StyledSwiper
        $hideNavigation={false}
        centeredSlidesBounds
        loop={true}
        modules={[NavigationModule, Scrollbar, Keyboard, A11y]}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        scrollbar={true}
        separator='true'
        slidesPerView={slidesPerView as number}
        spaceBetween={spaceBetween}
        watchSlidesProgress
      >
        {Children.map(children, (child, index) => (
          <SwiperSlide key={generateSliderKey(index)}>{child}</SwiperSlide>
        ))}
      </S.StyledSwiper>
      <Navigation ref={prevRef} type='prev' />
      <Navigation ref={nextRef} type='next' />
    </>
  );
};
